const FAQS = [
  {
    id: 1,
    q: '香蕉漫画网的漫画真的全部免费吗？',
    a: '是的！香蕉漫画网所有漫画资源均完全免费阅读，无需注册账号、无需购买会员、无需任何付费。我们致力于为漫画爱好者提供零成本的阅读体验，让每个人都能畅享全本漫画。',
  },
  {
    id: 2,
    q: '漫画更新频率如何？多久更新一次？',
    a: '我们与各大漫画平台保持同步更新，热门连载漫画通常在源站更新后1小时内即可在本站阅读。日均更新超过200部漫画，确保追更党不会错过任何最新话。',
  },
  {
    id: 3,
    q: '是否支持手机和平板阅读？',
    a: '完全支持！香蕉漫画网采用响应式设计，自动适配电脑、平板和手机等多种设备。无论你使用什么设备访问，都能获得流畅舒适的阅读体验，随时随地畅快追漫。',
  },
  {
    id: 4,
    q: '漫画种类有哪些？能找到冷门作品吗？',
    a: '本站收录漫画超过五万部，涵盖热血、恋爱、奇幻、悬疑、搞笑、都市、修仙、科幻、校园、国漫等多个品类。无论是热门大作还是小众冷门，你都能在这里找到心仪的作品。',
  },
  {
    id: 5,
    q: '网站有没有广告或者弹窗？',
    a: '我们坚持极简纯净的阅读理念，页面设计清爽简洁，不存在强制弹窗和干扰性广告。偶尔的运营信息展示也不会影响你的正常阅读，只为给你最好的漫画阅读环境。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            常见问答
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            关于香蕉漫画网，你想知道的都在这里
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {FAQS.map((faq) => (
            <div
              key={faq.id}
              className="rounded-xl bg-background-50 border border-background-200/70 p-5 md:p-6"
            >
              <h3 className="text-base font-heading font-bold text-foreground-900 mb-2 flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 text-xs font-bold mt-0.5">Q</span>
                {faq.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-9">{faq.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}